import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import Home from "./pages/Home";
import AllOfferingsPage from "./pages/AllOfferingsPage";
import PartnerOfferingsPage from "./pages/PartnerOfferingsPage";
import PartnerDetailPage from "./pages/PartnerDetailPage";
import CategoryPage from "./pages/CategoryPage";
import GenAIPage from "./pages/GenAIPage";
import DataAnalyticsAIPage from "./pages/DataAnalyticsAIPage";
import CloudDevOpsPage from "./pages/CloudDevOpsPage";
import CybersecurityPage from "./pages/CybersecurityPage";
import SoftwareEngineeringPage from "./pages/SoftwareEngineeringPage";
import ApplicationsPlatformsPage from "./pages/ApplicationsPlatformsPage";
import TestingPage from "./pages/TestingPage";
import MethodologiesFrameworksPage from "./pages/MethodologiesFrameworksPage";
import SoftSkillsPage from "./pages/SoftSkillsPage";
import ELearningPage from "./pages/ELearningPage";
import LXPPage from "./pages/LXPPage";
import ProductPage from "./pages/ProductPage";
import CorporateTrainingPage from "./pages/CorporateTrainingPage";
import NewHireTrainingPage from "./pages/NewHireTrainingPage";
import HireTrainDeployPage from "./pages/HireTrainDeployPage";
import ProctoredAssessmentsPage from "./pages/ProctoredAssessmentsPage";
import NicheSkillProjectsPage from "./pages/NicheSkillProjectsPage";
import { CertificationsPage, ResourcesPage, AboutPage } from "./pages/StaticPages";
import { BlogPage, WebinarsPage, WhitepapersPage, CaseStudiesPage, PracticeTestsPage, EventsPage } from "./pages/ResourcePages";
import ReviewsPage from "./pages/ReviewsPage";
import Contact from "./pages/Contact";
import DemoPage from "./pages/DemoPage";
import AdminLeadsPage from "./pages/AdminLeadsPage";

const RedirectPartnerSlug = () => {
  const { slug } = useParams();
  return <Navigate to={`/partnerofferings/${slug}`} replace />;
};

function App() {
  useEffect(() => {
    document.title = "SkillsGain — Enterprise Learning, E-Learning & LXP";
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home/>} />
          <Route path="/offerings" element={<Navigate to="/offerings/all" replace/>} />
          <Route path="/offerings/all" element={<AllOfferingsPage/>} />
          <Route path="/offerings/corporate-training" element={<Navigate to="/solution/corporate-training" replace/>} />
          <Route path="/partnerofferings" element={<PartnerOfferingsPage/>} />
          <Route path="/partnerofferings/:slug" element={<PartnerDetailPage/>} />
          <Route path="/offerings/partner" element={<Navigate to="/partnerofferings" replace/>} />
          <Route path="/offerings/partner/:slug" element={<RedirectPartnerSlug/>} />
          <Route path="/skillsprogram/genai" element={<GenAIPage/>} />
          <Route path="/skillsprogram/data-analytics-ai" element={<DataAnalyticsAIPage/>} />
          <Route path="/skillsprogram/cloud-devops" element={<CloudDevOpsPage/>} />
          <Route path="/skillsprogram/cybersecurity" element={<CybersecurityPage/>} />
          <Route path="/skillsprogram/software-engineering" element={<SoftwareEngineeringPage/>} />
          <Route path="/skillsprogram/applications-platforms" element={<ApplicationsPlatformsPage/>} />
          <Route path="/skillsprogram/testing" element={<TestingPage/>} />
          <Route path="/skillsprogram/methodologies-frameworks" element={<MethodologiesFrameworksPage/>} />
          <Route path="/skillsprogram/soft-skills" element={<SoftSkillsPage/>} />
          <Route path="/skillsprogram/:slug" element={<CategoryPage/>} />
          <Route path="/offerings/genai" element={<Navigate to="/skillsprogram/genai" replace/>} />
          <Route path="/offerings/data-analytics-ai" element={<Navigate to="/skillsprogram/data-analytics-ai" replace/>} />
          <Route path="/offerings/cloud-devops" element={<Navigate to="/skillsprogram/cloud-devops" replace/>} />
          <Route path="/offerings/cybersecurity" element={<Navigate to="/skillsprogram/cybersecurity" replace/>} />
          <Route path="/offerings/software-engineering" element={<Navigate to="/skillsprogram/software-engineering" replace/>} />
          <Route path="/offerings/applications-platforms" element={<Navigate to="/skillsprogram/applications-platforms" replace/>} />
          <Route path="/offerings/testing" element={<Navigate to="/skillsprogram/testing" replace/>} />
          <Route path="/offerings/methodologies-frameworks" element={<Navigate to="/skillsprogram/methodologies-frameworks" replace/>} />
          <Route path="/offerings/soft-skills" element={<Navigate to="/skillsprogram/soft-skills" replace/>} />
          <Route path="/offerings/:slug" element={<CategoryPage/>} />
          <Route path="/solution/corporate-training" element={<CorporateTrainingPage/>} />
          <Route path="/solution/new-hire-training" element={<NewHireTrainingPage/>} />
          <Route path="/solution/certifications" element={<CertificationsPage/>} />
          <Route path="/solution/managed-ld" element={<LXPPage/>} />
          <Route path="/solution/hire-train-deploy" element={<HireTrainDeployPage/>} />
          <Route path="/solution/proctored-assessments" element={<ProctoredAssessmentsPage/>} />
          <Route path="/solution/niche-skill-projects" element={<NicheSkillProjectsPage/>} />
          <Route path="/partners" element={<Navigate to="/partnerofferings" replace/>} />
          <Route path="/products/enterprise-lms" element={<LXPPage/>} />
          <Route path="/products/e-learning" element={<ELearningPage/>} />
          <Route path="/products/:slug" element={<ProductPage/>} />
          <Route path="/e-learning" element={<Navigate to="/products/e-learning" replace/>} />
          <Route path="/elearning" element={<Navigate to="/products/e-learning" replace/>} />
          <Route path="/lxp" element={<Navigate to="/products/enterprise-lms" replace/>} />
          <Route path="/certifications" element={<CertificationsPage/>} />
          <Route path="/resources" element={<ResourcesPage/>} />
          <Route path="/resources/blog" element={<BlogPage/>} />
          <Route path="/resources/webinars" element={<WebinarsPage/>} />
          <Route path="/resources/whitepapers" element={<WhitepapersPage/>} />
          <Route path="/resources/case-studies" element={<CaseStudiesPage/>} />
          <Route path="/resources/practice-tests" element={<PracticeTestsPage/>} />
          <Route path="/resources/events" element={<EventsPage/>} />
          <Route path="/reviews" element={<ReviewsPage/>} />
          <Route path="/about" element={<AboutPage/>} />
          <Route path="/contact" element={<Contact/>} />
          <Route path="/demo" element={<DemoPage/>} />
          <Route path="/admin/leads" element={<AdminLeadsPage/>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
